<nav class="nav" [class.mt]="mt">
  <div class="nav-logo">
    <img
      alt="redeban logo"
      [src]="baseUrl + '/assets/images/logo-redeban.svg'"
    />
  </div>
</nav>
